// extracted by mini-css-extract-plugin
export default {"socialButtons":"IconsSocial_socialButtons__4UNo+","socialButtons2":"IconsSocial_socialButtons2__ai64d"};